
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/mural-to-miro",
      function () {
        return require("private-next-pages/converter/mural-to-miro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/mural-to-miro"])
      });
    }
  